<template>
<div>
    <div v-if="isLoggedIn">
       <!-- navbar -->
       <nav class="navbar navbar-expand-lg navbar-dark aarp-navbar">
            <a class="navbar-brand" href=""><img src="../assets/img/logo.jpg" height="40" alt=""></a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent-3" aria-controls="navbarSupportedContent-3" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="row collapse navbar-collapse" id="navbarSupportedContent-3" v-if="isLoggedIn">
                <div class="col-sm-2" ></div>
                <div class="col-sm-7" >
                    <div class="navbar-nav arp-header">
                      <!-- <li class="nav-item" v-on:click="setActive('Home')" :class="{ active: isActive('Home') }">
                             <router-link class="nav-link waves-effect waves-light" to="/"> Home </router-link>
                           </li>
                      -->
                        <li class="nav-item" v-on:click="setActive('Metrics')" :class="{ tabactive: isActive('Metrics') }">
                            <router-link class="nav-link waves-effect waves-light" to="/metrics" style="font-weight: bold"> METRICS</router-link>
                        </li>
                        <li class="nav-item" style="margin-left: 25px; margin-right: 25px;" v-on:click="setActive('Targets')" :class="{ tabactive: isActive('Targets') }">
                            <router-link class="nav-link waves-effect waves-light" to="/commentary" style="font-weight: bold"> COMMENTS </router-link>
                        </li>
                        <li v-if="currentAccessLevel == 'admin'" class="nav-item" v-on:click="setActive('Configuration')" :class="{ tabactive: isActive('Configuration') }">
                            <router-link class="nav-link waves-effect waves-light" to="/configuration" style="font-weight: bold"> CONFIGURATION </router-link>
                        </li>
                    </div>
                </div>
                 <div class="col-sm-3">
                    <div class="navbar-nav" style="justify-content: flex-end">
                       <div v-if="isLoggedIn == true" class="nav-item user-section">
                           <div style="margin-right:30px;text-align:right">
                           <div style="width:100%">
                               <span style="font-weight:600">{{currentUserName}}</span>
                           </div>
                         <div style="width:100%"><span class="waves-effect waves-light">{{currentUserEmail}}</span></div>
                        </div>
                          <div class="avatar-circle" v-bind:style="{backgroundColor: '#A12118'}">
                                <span class="initials">{{currentUserEmail.split('').slice(0,2).join('').toUpperCase()}}</span>
                            </div>
                            <b-nav-item-dropdown right style="margin-left:-5px;">
                            <b-dropdown-item  @click="logout" style="width:300px;background-color:#A12118">
                                 <i class="fa fa-sign-out fa-2x" style="color:#ffffff" aria-hidden="true"></i>
                                 <span class="appheader-dropdown-menu-text">Logout</span></b-dropdown-item>
                            </b-nav-item-dropdown>
                       </div>
                    <div v-else class="nav-item">
                        <a class="nav-link waves-effect waves-light" @click="login">Login <i class="fa fa-sign-in" aria-hidden="true"></i></a>
                    </div>
                 </div>
              </div>
            </div>
        </nav>

       <!--/.Navbar-->
    </div>
</div>
    
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { Navbar, NavbarItem, NavbarNav, NavbarCollapse, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, mdbInput, Btn, waves, mdbNavbarBrand } from 'mdbvue';

export default {
    name: "AppHeader",
    computed: {
        ...mapGetters(['isLoggedIn','currentUserEmail','currentUserName','currentUserGroups','currentAccessLevel']),
        accessLevel: function(){
            console.log(`Current user groups from AppHeader. ${this.currentUserGroups}`)
            if(String(this.currentUserGroups).toLowerCase().indexOf('admin')>-1){
                return "admin"
            } else if(String(this.currentUserGroups).toLowerCase().indexOf('poweruser')>-1) {
                return "poweruser"
            } else if(String(this.currentUserGroups).toLowerCase().indexOf('readonly')>-1) {
                return "readonly"
            } else {
                return "unknown"
            }
        }
    },
        
    data(){
        return {activeItem: 'Metrics'}
    },
    methods: {
        ...mapActions(['login','logout']),
        isActive: function (menuItem) {
            return this.activeItem === menuItem
        },
        setActive: function (menuItem) {
            this.activeItem = menuItem // no need for Vue.set()
         }
    },
    // beforeMount() {
    //     this.$store.dispatch('storeInitializer').then(result => console.log(`Data for fetch in AppHeader: ${JSON.stringify(result,null,2)}`))
    // },
    components: {Navbar,NavbarItem,NavbarNav,NavbarCollapse,Dropdown,DropdownItem,DropdownMenu,DropdownToggle,mdbInput,Btn,waves,mdbNavbarBrand},
    watch: {
        isLoggedIn(to, from){
            console.log(`loggedIn value got updated from ${from} to ${to}`)
        }
    }
}
</script>

<style scoped>
.horizontal {
    display: flex;
    flex-direction: row;
}

.user-section {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}

.tabactive {
    border-bottom: 4px solid #FBC743;
    position: relative;
    bottom: -5px;
}

.arp-header {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    margin-top: 5px;
}

.avatar-circle {
  width: 42px;
  margin-right: 6px;
  height: 42px;
  text-align: center;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
}
.initials {
  position: relative;
  font-size: 18px; /* 50% of parent */
  line-height: 40px; /* 50% of parent */
  color: #fff;
}

</style>

<style>
.aarp-navbar {
    top: 0px;
    left: 0px;
    /*width: 1920px;*/
    height: 60px;
    background: #C12F24 0% 0% no-repeat padding-box;
    opacity: 1;
}
.navbar .dropdown-menu a:hover {
  color: inherit !important;
}
.nav-item {
    color: white;
}
.nav-item a:hover {
    color: #ddd;
}
.dropdown-menu.dropdown-menu-right.show
{
 background-color: #A12118;
 margin-top:8px;
 padding:0px;
}
.appheader-dropdown-menu-text
{
color:#ffffff;
font-size:18px;
padding-left:5px;
margin-top: 2px;
position: absolute;
}
</style>

